export const translations = {
  sv: {
    from: 'Från ',
    labelMaxDimensionsRoll: 'Rulle',
    labelMaxDimensions: 'Maxmått',
  },
  da: {
    from: 'Fra ',
    labelMaxDimensionsRoll: 'Rulle',
    labelMaxDimensions: 'Maks. mål og vægt',
  },
  en: {
    from: 'From ',
    labelMaxDimensionsRoll: 'Roll',
    labelMaxDimensions: 'Maximum dimensions',
  },
};
